module.exports = __webpack_public_path__ + "img/gray.b7fbbfc0.png";